module.exports = __webpack_public_path__ + "static/media/exemplo-documento.0e9f96b4.webp";